<template>
    <ProgressSpinner v-if="loading"/>
    <Container class="pt-6" v-if="!loading">
        <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
            <PageHeading>{{ firmwareName }}</PageHeading>
        </div>

        <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
            <TabLayout :tabs="tabs" sticky/>
        </div>

        <router-view
            @on-save="onSave"
            @on-delete="$emit('on-delete')"
            @on-loaded="firmwareName = $event"
        ></router-view>
    </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import Container from "@/Components/Container.vue";

export default {
    name: "DeviceThirdPartyFirmwareView",
    components: {Container, TabLayout, PageHeading},
    data() {
        return {
            loading: false,
            firmwareName: null,
        };
    },
    emits: ['on-save', 'on-delete'],
    watch: {
        '$route.params.firmware': {
            handler(newValue) {
                if (newValue) {
                    this.firmwareName = newValue === 'NEW' ? 'NEW' : newValue;
                } else {
                    this.firmwareName = null;
                }
            },
            immediate: true,
        }
    },
    methods: {
        onSave(versionNumber) {
            if (versionNumber) {
                this.firmwareName = versionNumber;
            }
            this.$emit('on-save');
        },
    },
    computed: {
        tabs() {
            return [
                {
                    label: this.$t('common.properties'),
                    current: this.$route.name === 'admin.devices.third-party-firmwares.firmware.properties',
                    to: {name: 'admin.devices.third-party-firmwares.firmware.properties', params: this.$route.params},
                },
            ];
        },
    },
};
</script>
